import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#ABB3A4] text-black py-8 text-center">
      <div className="container mx-auto px-6">
        <h3 className="text-lg font-semibold">Escritório de Advocacia</h3>
        <p className="mt-2 text-gray-800">Protegendo seus direitos com ética e excelência.</p>
        <div className="flex justify-center mt-4 space-x-4">
          <a href="/sobre" className="text-gray-900 hover:text-gray-600 transition">Sobre</a>
          <a href="/servicos" className="text-gray-900 hover:text-gray-600 transition">Serviços</a>
          <a href="/contato" className="text-gray-900 hover:text-gray-600 transition">Contato</a>
        </div>
        
        {/* Redes Sociais */}
        <div className="mt-6 flex justify-center space-x-6">
          <a href="#" className="text-gray-900 hover:text-gray-600 transition">
            <i className="fab fa-facebook-f"></i> Facebook
          </a>
          <a href="#" className="text-gray-900 hover:text-gray-600 transition">
            <i className="fab fa-instagram"></i> Instagram
          </a>
          <a href="#" className="text-gray-900 hover:text-gray-600 transition">
            <i className="fab fa-linkedin-in"></i> LinkedIn
          </a>
        </div>

        <p className="mt-6 text-gray-700 text-sm">© {new Date().getFullYear()} Escritório de Advocacia. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;